import {
  ArrowCounterClockwise,
  SlidersHorizontal,
} from "@phosphor-icons/react";
import clsx from "clsx";
import { useState } from "react";

import BadgeWrapper from "common/components/BadgeWrapper";
import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerTrigger,
} from "common/components/ui/Drawer";

import FiltersSelection from "./Filters";

import type {
  NavigatorFilters,
  SelectedNavigatorFilters,
} from "../../../../../types";

export default function MobileFilters({
  isLoading,
  returnedFilters,
  selectedFilters,
  setSelectedFilters,
}: {
  isLoading: boolean;
  returnedFilters: NavigatorFilters;
  selectedFilters: SelectedNavigatorFilters;
  setSelectedFilters: (selectedFilters: SelectedNavigatorFilters) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <BadgeWrapper
        badgeClassName={clsx(
          "right-0 -top-0 size-4",
          !selectedFilters.length && "hidden",
        )}
      >
        <DrawerTrigger asChild>
          <Button variant="outline-black" intent="iconOnly">
            <SlidersHorizontal />
          </Button>
        </DrawerTrigger>
      </BadgeWrapper>
      <DrawerContent className="pb-16">
        <div className="flex flex-col overflow-auto">
          <Button
            variant="secondary-black"
            className={clsx(
              "mb-4 ml-auto",
              !selectedFilters.length && "invisible",
            )}
            size="sm"
            leftIcon={<ArrowCounterClockwise />}
            onClick={() => setSelectedFilters([])}
          >
            Reset all
          </Button>
          <FiltersSelection
            isSingleColumn
            isLoading={isLoading}
            returnedFilters={returnedFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </div>
        <DrawerFooter>
          <DrawerClose asChild>
            <Button className="w-full">Done</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
